document.addEventListener('DOMContentLoaded', function () {
    const menuOpenBtn = document.querySelector('.js--hamburger-menu.-open');
    const menuCloseBtn = document.querySelector('.js--hamburger-menu.-close');
    const hasSeparateButtons = Boolean(menuOpenBtn && menuCloseBtn);
    const menuToggleBtn = hasSeparateButtons ? null : document.querySelector('.js--hamburger-menu');
    const drawerMenu = document.querySelector('.js--drawer-menu');
    // const bodyInner = document.querySelector('.js--body-inner');

    if (!drawerMenu) return;

    // スクロール位置を保持（閉じた時に戻す）
    let savedScroll = 0;

    /**
     * メニューを開く処理
     */
    function openMenu() {
        drawerMenu.classList.add('select');

        const scrollPos = window.scrollY || window.pageYOffset || 0;
        savedScroll = scrollPos;
        // bodyInner.dataset.scroll = String(scrollPos);

        // bodyInner.classList.add('scroll-prevent');
        // bodyInner.style.top = `-${scrollPos}px`;

        drawerMenu.setAttribute('aria-hidden', 'false');

        // ボタンが1つの場合でも見た目を切り替えられるようにしておく
        if (menuToggleBtn) {
            menuToggleBtn.classList.remove('-open');
            menuToggleBtn.classList.add('-close');
            menuToggleBtn.setAttribute('aria-expanded', 'true');
        }
        if (menuOpenBtn) menuOpenBtn.setAttribute('aria-expanded', 'true');
    }

    /**
     * メニューを閉じる処理
     */
    function closeMenu() {
        drawerMenu.classList.remove('select');

        // bodyInner.classList.remove('scroll-prevent');
        // bodyInner.style.top = '0px';

        // const savedScroll = Number(bodyInner.dataset.scroll || 0);
        // ※スクロール固定処理をしていないため、ここで scrollTo すると
        // data-anchor のスクロール等を打ち消してしまう

        drawerMenu.setAttribute('aria-hidden', 'true');

        if (menuToggleBtn) {
            menuToggleBtn.classList.remove('-close');
            menuToggleBtn.classList.add('-open');
            menuToggleBtn.setAttribute('aria-expanded', 'false');
        }
        if (menuOpenBtn) menuOpenBtn.setAttribute('aria-expanded', 'false');
    }

    function toggleMenu() {
        if (drawerMenu.classList.contains('select')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    // 1個構成（トグル）
    if (menuToggleBtn) {
        menuToggleBtn.addEventListener('click', toggleMenu);
    }

    // 2個構成（従来通り）にも対応
    if (menuOpenBtn) menuOpenBtn.addEventListener('click', openMenu);
    if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeMenu);

    // ドロワー内リンク押下で閉じる（href無しの a[data-anchor] も対象）
    drawerMenu.addEventListener('click', function (e) {
        const target = e.target;
        if (!(target instanceof Element)) return;

        const link = target.closest('a');
        if (!link) return;

        const hasHref = link.hasAttribute('href') && String(link.getAttribute('href') || '').trim() !== '';
        const hasAnchorData = link.hasAttribute('data-anchor');

        if (hasHref || hasAnchorData) {
            closeMenu();
        }
    });
});